import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import { motion } from "framer-motion";
import "react-vertical-timeline-component/style.min.css";

import { SectionWrapper } from "./SectionWrapper";
import { experiences } from "../utils/constants";
import { theme } from "../utils/theme";
import styles from "./Experience.module.css";
import "./Experience.css";

const ExperienceCard = ({ experience }) => {
  return (
    <VerticalTimelineElement
      contentStyle={{
        background: theme.colorCardBg,
        color: theme.colorText,
      }}
      contentArrowStyle={{ borderRight: `7px solid ${theme.colorCardArrow}` }}
      date={experience.date}
      iconStyle={{
        background: experience.iconBg,
      }}
      icon={
        <img
          src={experience.icon}
          alt={experience.company_name}
          className="image-icon"
        />
      }
    >
      <div>
        <h3 className={styles.title}>{experience.title}</h3>
        <p className={styles.company}>{experience.company_name}</p>
      </div>

      <ul className={styles.points}>
        {experience.points.map((point, index) => (
          <li key={`experience-point-${index}`} className={styles.point}>
            {point}
          </li>
        ))}
      </ul>
    </VerticalTimelineElement>
  );
};

const Experience = () => {
  return (
    <section className="experience">
      <motion.div>
        <h2 className="work-headertext">Experience Timeline</h2>
      </motion.div>
      <VerticalTimeline>
        {experiences.map((experience, index) => (
          <ExperienceCard key={`experience-${index}`} experience={experience} />
        ))}
      </VerticalTimeline>
    </section>
  );
};

export default SectionWrapper(Experience, "experience");
